import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'shell-models-lib';
import {
    AzurePostgreSqlLinkedServiceAdapter,
    azurePostgreSqlLinkedServiceAdapts
} from 'app/model/adapters/linkedservices/azure-db-postgre-linkedservice.adapter';
import { AzureHorizonDBLinkedService } from 'app/model/linkedservice/azure-horizon-db.linkedservice';

// Azure HorizonDB is PostgreSQL wire-compatible, so it reuses the exact same serialization
// spec and adapter behavior as Azure Database for PostgreSQL.
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureHorizonDBLinkedService),
    asynchronous: true,
    adapts: azurePostgreSqlLinkedServiceAdapts
})
export class AzureHorizonDBLinkedServiceAdapter extends AzurePostgreSqlLinkedServiceAdapter {
    protected override modelConstructor(): new () => AzureHorizonDBLinkedService {
        return AzureHorizonDBLinkedService;
    }

    protected override model(): IModel {
        return AzureHorizonDBLinkedService.MODEL;
    }

    protected override async propertiesToResourceAsync(
        linkedService: AzureHorizonDBLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const resource = await super.propertiesToResourceAsync(linkedService, linkedServiceResource);
        // HorizonDB has no version concept; never surface it in the payload.
        delete (resource.properties as Model.AzureHorizonDBLinkedService).version;
        return resource;
    }

    protected override async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: AzureHorizonDBLinkedService
    ): Promise<AzureHorizonDBLinkedService> {
        // HorizonDB payloads carry no `version`; force the modern (v2) parse path, then restore the incoming resource.
        const properties = linkedServiceResource.properties as Model.AzureHorizonDBLinkedService;
        properties.version = '2.0';
        try {
            return (await super.propertiesToModelAsync(linkedServiceResource, linkedService)) as AzureHorizonDBLinkedService;
        } finally {
            delete properties.version;
        }
    }
}
